import Layout from '@/layout';
var activityRouter = {
  path: '/activity',
  component: Layout,
  redirect: '/activity/financial-details',
  name: 'activity',
  alwaysShow: true,
  meta: {
    title: '活动管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'promotion-management',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/promotion-management/index.vue'], resolve);
    },
    name: 'promotion-management',
    meta: {
      title: '推广管理',
      icon: ''
    }
  }, {
    path: 'goods-joint',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/goods-joint/index.vue'], resolve);
    },
    name: 'goods-joint',
    meta: {
      title: '组合商品',
      icon: ''
    }
  }, {
    path: 'discount-coupon',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/discount-coupon/index.vue'], resolve);
    },
    name: 'discount-coupon',
    meta: {
      title: '优惠券',
      icon: ''
    }
  }, {
    path: 'withdraw-deposit',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/withdraw-deposit/index.vue'], resolve);
    },
    name: 'withdraw-deposit',
    meta: {
      title: '提现服务',
      icon: ''
    }
  }, {
    path: 'shopping-card-setting',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/shopping-card-setting/index.vue'], resolve);
    },
    name: 'shopping-card-setting',
    meta: {
      title: '购物卡配置',
      icon: ''
    }
  }, {
    path: 'recharge',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/recharge/index.vue'], resolve);
    },
    name: 'recharge',
    meta: {
      title: '充值',
      icon: ''
    }
  }, {
    path: 'discount-limited-time',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/discount-limited-time/index.vue'], resolve);
    },
    name: 'discount-limited-time',
    meta: {
      title: '限时折扣',
      icon: ''
    }
  }, {
    path: 'full-reduction-discount',
    component: function component(resolve) {
      return require(['@/views/my-create/management-activities/full-reduction-discount/index.vue'], resolve);
    },
    name: 'full-reduction-discount',
    meta: {
      title: '满减赠折',
      icon: ''
    }
  }]
};
export default activityRouter;